import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const WORDS = ["GRIND", "ACHIEVE", "MOTIVATE", "EXCEL", "MENTORSHIP", "LEADERSHIP"];

export const MarqueeStrip = () => (
  <div className="border-y border-[#242436] bg-[#0C0C12] py-6 overflow-hidden" data-testid="editorial-marquee">
    <Marquee speed={26} gradient={false} pauseOnHover>
      {WORDS.map((w, i) => (
        <span key={w} className="flex items-center shrink-0">
          <span
            className={`font-display font-black uppercase tracking-wide text-4xl sm:text-5xl px-6 ${
              i % 2 === 0 ? "text-[#F4F4F6]" : "text-outline"
            }`}
          >
            {w}
          </span>
          <Asterisk className="w-7 h-7 text-[#8B5CF6]" strokeWidth={2.5} />
        </span>
      ))}
    </Marquee>
  </div>
);
